import { render, staticRenderFns } from "./PageHeaderNoSidebar.vue?vue&type=template&id=772c29a9"
import script from "./PageHeaderNoSidebar.vue?vue&type=script&lang=js"
export * from "./PageHeaderNoSidebar.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderNoSidebar.vue?vue&type=style&index=0&id=772c29a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports